import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [token, setToken] = useState(() => localStorage.getItem("cc_admin_token"));
  const [email, setEmail] = useState(() => localStorage.getItem("cc_admin_email"));
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const verify = async () => {
      if (!token) {
        setLoading(false);
        return;
      }
      try {
        const { data } = await api.get("/admin/me");
        setEmail(data.email);
      } catch (err) {
        localStorage.removeItem("cc_admin_token");
        localStorage.removeItem("cc_admin_email");
        setToken(null);
        setEmail(null);
      } finally {
        setLoading(false);
      }
    };
    verify();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const login = (newToken, newEmail) => {
    localStorage.setItem("cc_admin_token", newToken);
    localStorage.setItem("cc_admin_email", newEmail);
    setToken(newToken);
    setEmail(newEmail);
  };

  const logout = () => {
    localStorage.removeItem("cc_admin_token");
    localStorage.removeItem("cc_admin_email");
    setToken(null);
    setEmail(null);
  };

  return (
    <AuthContext.Provider value={{ token, email, login, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
